import styled from "@emotion/styled";
import { ThemeStyle } from "assets/scss/common/theme";


export const PaymentBody = styled.div`
    border-top: 2px solid ${({ theme }: ThemeStyle) => theme.grey.G1};
    padding-bottom: 10px;
    padding-top: 0px;
    .required-symbol {
      color: ${({ theme }: ThemeStyle) => theme.red};
  }

 
`;

export const UpiIntentPollingScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 180px;
`;

export const SectionTitleWrapper = styled.div<{ theme: Theme }>`
  margin-bottom: ${({ theme }) => theme.sectionTitleSpacingBottom};
`;
